<div class="row" *ngIf="!sessionService.isAuthenticated()">
    <div class="col-md-12 col-lg-6">
        <div class="row justify-content-lg-center white-panel">
          <div class="col-md-12  col-lg-10">
            <h3 class="text-center"><i class="fa-solid fa-triangle-exclamation attention"></i>  Attention <i class="fa-solid fa-triangle-exclamation attention"></i></h3>
            <hr>
            <div>
              <p>Due to newly implemented security features, all existing users wishing to access PAETEP after July 13, 2024 will need to reset their password.</p>
              <p><span class="small">This does not apply to users who use SSO (Microsoft and Google) or users created after July 13, 2024.</span></p>
              <h1 class="form-text text-center"><a uiSref="public.forgot-password">Reset Your Password</a></h1>
            </div>
        </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-6">
        <div class="row justify-content-lg-center white-panel">
            <div class="col-md-12 col-lg-10">
                <ui-view name="login-content"></ui-view>
            </div>
        </div>
    </div>
</div>
